import React from 'react'
import { Box } from '@urbaninfrastructure/react-ui-kit'

export default function GridExample(props: any) {
  return <Box bg="primary" color="white" p={3} mb={3} {...props} />
}
